import { render } from "./Cat_service.vue?vue&type=template&id=720fe6ac&scoped=true"
import script from "./Cat_service.vue?vue&type=script&lang=js"
export * from "./Cat_service.vue?vue&type=script&lang=js"

import "./Cat_service.vue?vue&type=style&index=0&id=720fe6ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720fe6ac"]])

export default __exports__